module.exports = __webpack_public_path__ + "project/img/sign.85687d48.jpg";